// extracted by mini-css-extract-plugin
export default {"container":"Pages_container__wryhp","top":"Pages_top__nTvUd","pageNumber":"Pages_pageNumber__x+7Aj"};